<script lang="ts" setup>
import { type Component as VueComponent, type PropType, ref } from "vue";

import { loginRequest } from "@/common/login.service";

const props = defineProps({
  tag: {
    type: [String, Object] as PropType<string | VueComponent>,
    default: "button"
  },
  redirectUrl: {
    type: String,
    default: "/dictionary"
  }
});

const isLoggingIn = ref(false);

const login = async () => {
  isLoggingIn.value = true;
  await loginRequest("login", props.redirectUrl);
  isLoggingIn.value = false;
};
</script>

<template>
  <Component :is="tag" :aria-disabled="isLoggingIn" :disabled="isLoggingIn" @click="login()">
    <slot></slot>
  </Component>
</template>
